<template>
	<div :class="'companies-card'">
		<div class="companies-card__main">
			<Ellipsis
				:data="costumerCompany"
				class="companies-card__title"
			></Ellipsis>
			<div class="companies-card__oem-tags">
				<TagLabel message="Chrysler" :state="'neutral'" />
				<TagLabel message="Dodge" :state="'neutral'" />
				<TagLabel message="Jeep" :state="'neutral'" />
			</div>
		</div>
		<ActionsSet
			class="companies-card__actions"
			:variant="variant"
			:options="actions"
		/>
	</div>
</template>

<script>
import Ellipsis from '@/components/visual/ellipsis';
import ActionsSet from '@/site-components/actions-set/actions-set';
import TagLabel from '@/components/visual/tag-label';

export default {
	name: 'CompaniesCard',
	components: {
		Ellipsis,
		ActionsSet,
		TagLabel
	},
	props: {
		companyData: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			actions: [
				{
					id: 1,
					action: {
						name: 'company-settings'
					},
					title: 'Select to go to Company Settings',
					iconClass: 'icon icon-manage',
					label: 'Settings',
					type: 'route-link',
					visible: true
				},
				{
					id: 2,
					action: {
						name: 'error-log'
					},
					title: 'Select to go to Error Log',
					iconClass: 'icon icon-error',
					label: 'Error Log',
					type: 'route-link',
					visible: true
				},
				{
					id: 3,
					action: {
						name: 'integrations-manager'
					},
					iconClass: 'icon icon-customer-integration',
					label: 'Integration',
					title: 'Select to go to Client Integrations',
					type: 'route-link',
					visible: true
				},
				{
					id: 4,
					action: {
						name: 'transactions'
					},
					iconClass: 'icon icon-transaction',
					label: 'Transactions',
					title: 'Select to go to Client Transactions',
					type: 'route-link',
					visible: true
				}
			]
		};
	},
	computed: {
		costumerCompany() {
			return `${this.companyData.customerName} - ${this.companyData.data.advanced.companyName}`;
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.companies-card {
	@include card;
	display: grid;
	row-gap: $gutter-md;
	align-items: start;
	font-size: $default-font-size - 2;

	&__main {
		min-width: 0;
	}

	&__title {
		cursor: default;
		@include heading('md');
		text-transform: capitalize;
		margin-bottom: $gutter-sm;
	}

	&__oem-tags {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		gap: $gutter-md;
		margin-top: $gutter-lg;
		margin-bottom: $gutter-md;
	}

	&__actions {
		align-self: flex-end;
		display: flex;
		flex-direction: column;
	}
}
</style>
